import { render, staticRenderFns } from "./SeperationTrade.vue?vue&type=template&id=6890720c&"
import script from "./SeperationTrade.vue?vue&type=script&lang=js&"
export * from "./SeperationTrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports